// API reason → `chargebacks.reasons.<camelCaseKey>` in the banking catalogue.
// The values on the left are API enums and stay untranslated.
const REASON_KEYS = {
    absence_of_print: 'absenceOfPrint',
    absent_card_fraud: 'absentCardFraud',
    card_activated_phone_transaction: 'cardActivatedPhoneTransaction',
    card_fraud: 'cardFraud',
    card_recovery_bulletin: 'cardRecoveryBulletin',
    commercial_disagreement: 'commercialDisagreement',
    copy_not_received: 'copyNotReceived',
    credit_or_debit_presentation_error: 'creditOrDebitPresentationError',
    different_pay_method: 'differentPayMethod',
    fraud: 'fraud',
    incorrect_transaction_value: 'incorrectTransactionValue',
    invalid_currency: 'invalidCurrency',
    invalid_data: 'invalidData',
    late_presentation: 'latePresentation',
    local_regulatory_or_legal_dispute: 'localRegulatoryOrLegalDispute',
    multiple_rocs: 'multipleRocs',
    original_credit_transaction_not_accepted: 'originalCreditTransactionNotAccepted',
    other_absent_card_fraud: 'otherAbsentCardFraud',
    process_error: 'processError',
    received_copy_illegible_or_incomplete: 'receivedCopyIllegibleOrIncomplete',
    recurrence_canceled: 'recurrenceCanceled',
    required_authorization_not_granted: 'requiredAuthorizationNotGranted',
    right_of_full_recourse_for_fraud: 'rightOfFullRecourseForFraud',
    sale_canceled: 'saleCanceled',
    service_disagreement_or_defective_product: 'serviceDisagreementOrDefectiveProduct',
    service_not_received: 'serviceNotReceived',
    split_sale: 'splitSale',
    transfers_of_diverse_responsibilities: 'transfersOfDiverseResponsibilities',
    unqualified_car_rental_debit: 'unqualifiedCarRentalDebit',
    usa_cardholder_dispute: 'usaCardholderDispute',
    visa_fraud_monitoring_program: 'visaFraudMonitoringProgram',
    warning_bulletin_file: 'warningBulletinFile',
    fraudulent: 'fraudulent',
    duplicate: 'duplicate',
    credit_not_processed: 'creditNotProcessed',
    product_not_received: 'productNotReceived',
    product_unacceptable: 'productUnacceptable',
    subscription_canceled: 'subscriptionCanceled',
    general: 'general',
};

// `t` is injected by the component (it belongs to the "banking" namespace), so
// the copy resolves at render time and follows the active language.
export function getChargebackReason(t, reason) {
    const key = REASON_KEYS[reason];

    if (!key) {
        return {
            label: reason || t('chargebacks.reasons.unknown.label'),
            description: t('chargebacks.reasons.unknown.description'),
            instructions: t('chargebacks.reasons.unknown.instructions'),
        };
    }

    return {
        label: t(`chargebacks.reasons.${key}.label`),
        description: t(`chargebacks.reasons.${key}.description`),
        instructions: t(`chargebacks.reasons.${key}.instructions`),
    };
}

export default REASON_KEYS;
